import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Modal,
  Pagination,
  Radio,
  Row,
  Table,
} from "antd";
import Search from "antd/es/input/Search";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

import inquiryApi from "../../../apis/Inquiry.api";
import productApi from "../../../apis/Product.api";
import pushApi from "../../../apis/Push.api";
import userApi from "../../../apis/User.api";
import {
  setLoading,
  setSearchText,
} from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import RecommendProductComponent from "./RecommendProductComponent";

const { Panel } = Collapse;

const RecommendInquiryBoardComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const searchText = useSelector((state) => state.common.searchText);
  const recordDates = useSelector((state) => state.common.recordDates);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const setIsSearchText = (value) => dispatch(setSearchText(value));

  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    answerStatus: "unanswer",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("updated_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [inquiryList, setInquiryList] = useState([]);
  const [selectInquiry, setSelectInquiry] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [recommendInquiryAnswer, setRecommendInquiryAnswer] = useState({
    greetings: "",
    additional: "",
  });
  const [selectedReasonRowKey, setSelectedReasonRowKey] = useState([]);
  const [selectedReasonRow, setSelectedReasonRow] = useState([]);
  const [selectedReasonList, setSelectedReasonList] = useState([]);
  const [selectedNutrientsList, setSelectedNutrientsList] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [recommendReasonList, setRecommendReasonList] = useState([]);
  const [nutrientsList, setNutrientsList] = useState({
    vitamin: [],
    mineral: [],
    nutrition: [],
  });
  const [productItemList, setProductItemList] = useState([]);
  const [error, setError] = useState("");
  // // const searchReasonInput = useRef(null)
  const searchInput = useRef(null);

  const answerStatusItems = [
    { label: "전체", value: "total" },
    { label: "답변대기", value: "unanswer" },
    { label: "답변완료", value: "answer" },
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
    { label: "1년", value: "1year" },
  ];
  const reasonRowSelection = {
    selectedRowKeys: selectedReasonRowKey,
    onSelect: (record) => {
      let editTotalRow = [];
      let editRow = [];
      let editRowKey = [];
      const greetingsList = recommendInquiryAnswer.greetings.split(":)");
      const splitted = greetingsList[1].split("\n");
      const findReasonStrIdx = splitted.findIndex((str) =>
        str.includes("위와 같은 이유로"),
      );
      const greetingsStart = greetingsList[0] + ":)";
      const greetingsEnd = splitted.slice(findReasonStrIdx).join("\n");
      const copyReasonList = splitted.slice(0, findReasonStrIdx);
      if (copyReasonList?.length > 2 && copyReasonList[0] === "") {
        copyReasonList.shift();
      }
      let reasonStr = copyReasonList.join("\n");
      const reasonList = reasonStr.split("\n").filter((str) => str !== "");
      const selectReasonList = selectedReasonList.map(
        (reason) => reason.reason,
      );
      if (selectReasonList.includes(record.reason)) {
        editTotalRow = selectedReasonList.filter(
          (row) => row.reason !== record.reason,
        );
        editRow = selectedReasonRow.filter(
          (row) => row.reason !== record.reason,
        );
        editRowKey = selectedReasonRowKey.filter((key) => key !== record.id);
      } else {
        editTotalRow = [...selectedReasonList, record];
        editRow = [...selectedReasonRow, record];
        editRowKey = [...selectedReasonRowKey, record.id];
      }
      for (const row of editTotalRow) {
        if (!reasonList.includes(row.reason)) {
          reasonStr += `${
            row.reason.includes("XX")
              ? row.reason.replaceAll(
                  "XX",
                  selectInquiry.inquiry.created_by_name,
                )
              : row.reason
          }\n`;
        } else {
          const findIdx = reasonList.findIndex(
            (reason) => reason === row.reason,
          );
          if (findIdx !== -1) {
            reasonList.splice(findIdx, 1);
          }
        }
      }
      if (reasonList?.length > 0) {
        for (const reason of reasonList) {
          reasonStr = reasonStr.replace(`${reason}\n`, "");
        }
      }
      if (reasonStr === "\n") {
        reasonStr = "";
      }
      setSelectedReasonRowKey(editRowKey);
      setSelectedReasonRow(editRow);
      setSelectedReasonList(editTotalRow);
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings:
          greetingsStart +
          "\n" +
          reasonStr +
          "\n" +
          (greetingsEnd.includes(":)") ? greetingsEnd : greetingsEnd + ":) )"),
      });
    },
  };
  const productRowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record) => {
      let editTotalRow = [];
      let editRow = [];
      let editRowKey = [];
      const greetingsList =
        recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
      let productNameStr = greetingsList[1].split("추천드립니다.")[0];
      const productNameList = productNameStr.split("\n");
      if (productNameList?.length === 1 && productNameList[0] === "") {
        productNameList.pop();
      }
      const productIdList = selectedProductList.map(
        (product) => product.product_id,
      );
      if (productIdList.includes(record.product_id)) {
        editTotalRow = selectedProductList.filter(
          (row) => row.product_id !== record.product_id,
        );
        editRow = selectedRow.filter(
          (row) => row.product_id !== record.product_id,
        );
        editRowKey = selectedRowKey.filter((key) => key !== record.product_id);
      } else {
        editTotalRow = [...selectedProductList, record];
        editRow = [...selectedRow, record];
        editRowKey = [...selectedRowKey, record.product_id];
      }
      for (const row of editTotalRow) {
        if (!productNameStr.includes(row.product_name)) {
          productNameStr += `"[${row.product_brand_name}] ${row.product_name}"\n`;
        } else {
          const findIdx = productNameList.findIndex((productName) =>
            productName.includes(row.product_name),
          );
          if (findIdx !== -1) {
            productNameList.splice(findIdx, 1);
          }
        }
        if (!row.hasOwnProperty("content")) {
          if (row.information_3 !== null) {
            row["content"] =
              row.information_1 +
              "\n\n" +
              row.information_2 +
              "\n\n" +
              row.information_3;
          } else if (row.information_2 !== null) {
            row["content"] = row.information_1 + "\n\n" + row.information_2;
          } else if (row.information_1 !== null) {
            row["content"] = row.information_1;
          } else {
            row["content"] = null;
          }
        }
        if (!row.hasOwnProperty("recommend_tag")) {
          row["recommend_tag"] = "";
        }
      }
      productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
      if (productNameList?.length > 0) {
        for (const productName of productNameList) {
          const deleteName = productName.replace(/(["'])\s/gim, `"`);
          productNameStr = productNameStr.replace(`${deleteName}\n`, "");
        }
      }
      productNameStr = productNameStr + "추천드립니다.";
      const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
      if (lastIdx !== -1) {
        productNameStr =
          productNameStr.substring(0, lastIdx) +
          " " +
          productNameStr.substring(lastIdx + 1);
      }
      setSelectedRowKey(editRowKey);
      setSelectedRow(editRow);
      setSelectedProductList(editTotalRow);
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings:
          greetingsList[0] +
          "이에 관련한 영양제로는\n" +
          productNameStr +
          (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
          greetingsList[1].split("추천드립니다.")[1],
      });
    },
  };
  const columns = [
    {
      title: "등록일시",
      // width: 200,
      dataIndex: "updated_at",
      key: "updated_at",
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "고객명",
      // width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "제목",
      // width: 90,
      dataIndex: "title",
      key: "title",
      ellipsis: true,
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setIsOpen(true);
              getInquiryOne(record.id);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "내용",
      dataIndex: "content",
      key: "content",
      ellipsis: true,
    },
    {
      title: "답변상태",
      // width: 90,
      dataIndex: "answer_status",
      key: "answer_status",
      ellipsis: true,
      render: (value, record) => {
        if (value) {
          const questionDate = moment(record.updated_at);
          const answerDate = moment(record.answer_created_at);
          const durationMinutes = Math.floor(
            moment.duration(answerDate.diff(questionDate)).asMinutes(),
          );
          return `${durationMinutes}분 후 답변완료`;
        } else {
          return "미답변";
        }
      },
    },
  ];
  const reasonColumns = [
    {
      title: "추천이유",
      dataIndex: "reason",
      key: "reason",
    },
  ];
  const productColumns = [
    {
      title: "브랜드명",
      dataIndex: "product_brand_name",
      key: "product_brand_name",
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
    },
  ];

  useEffect(() => {
    getNutrientList();
    if (searchText && searchText !== " ") {
      setDateType("");
      setSearchOptions({
        ...searchOptions,
        startDate: recordDates.startDate,
        endDate: recordDates.endDate,
        answerStatus: "unanswer",
      });
      getInquiryList("custom", recordDates.startDate, recordDates.endDate);
    } else {
      handleInitialBtnClick();
    }
  }, [searchText]);

  useEffect(() => {
    getInquiryList();
    // if (searchText && searchText !== " ") {
    //     getInquiryList("custom", recordDates.startDate, recordDates.endDate)
    // } else {
    //     getInquiryList()
    // }
  }, [offset, pageSize, orderType, orderBy]);

  useEffect(() => {
    handleSearchRecommendReason("");
    handleSearchProduct("");
    if (
      Object.keys(selectInquiry)?.length !== 0 &&
      selectInquiry.inquiry.id &&
      selectInquiry.answerList?.length > 0
    ) {
      settingAnswer();
    } else if (
      Object.keys(selectInquiry)?.length !== 0 &&
      selectInquiry.inquiry.id &&
      selectInquiry.answerList?.length === 0
    ) {
      setRecommendInquiryAnswer({
        ...recommendInquiryAnswer,
        greetings: `안녕하세요, ${selectInquiry.inquiry.created_by_name}님!\n당신의 영양제 헬시팀입니다 :)\n\n위와 같은 이유로 ${selectInquiry.inquiry.created_by_name}님께는 필요한 것으로 분석되며, 이에 관련한 영양제로는\n추천드립니다.`,
        additional: `제품에 대해 자세히 살펴보실 수 있도록 하단에 링크를 첨부해드리니 도움이 되시길 바라겠습니다 :)\n\n마침 인플루언서 "인플루언서명"님과의 협업을 통해 상담을 진행하신 분에 한해 7일 동안 사용하실 수 있는 10,000원 할인쿠폰을 제공해드리고 있으니 구매에 참고하시면 좋겠습니다!\n\n당신의 영양제 헬시팀의 영양제 추천이 도움이 되셨길 바라며, 당신의 매일이 건강했으면 좋겠습니다!\n\n감사합니다. 당신의 영양제 :)\n\n(${selectInquiry.inquiry.created_by_name}께 당신의 영양제에서 추천드리는 제품은 치료를 목적으로 하는 의약품이 아님을 알려드립니다.)`,
      });
    }
  }, [selectInquiry.inquiry]);

  const getNutrientList = async () => {
    setIsLoading(true);
    try {
      const res = await productApi.readNutrientList();
      if (res.code === 200) {
        setNutrientsList({
          ...nutrientsList,
          vitamin: res.result.vitamin,
          mineral: res.result.mineral,
          nutrition: res.result.nutrition,
        });
      } else {
        throw `영양소 정보를 불러오는데 실패하였습니다. 다시 시도해주시길 바랍니다.`;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  const getInquiryList = async (type = "", startDate, endDate) => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await inquiryApi.readRecommendInquiryList(
          0,
          10,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          answerStatusItems[1].value,
          "updated_at",
          "desc",
        );
      } else if (type === "search") {
        res = await inquiryApi.readRecommendInquiryList(
          0,
          10,
          searchOptions.startDate.format("YYYYMMDDHHmm"),
          searchOptions.endDate.format("YYYYMMDDHHmm"),
          searchOptions.answerStatus,
          orderType,
          orderBy,
        );
      } else if (type === "custom") {
        res = await inquiryApi.readRecommendInquiryList(
          offset,
          pageSize,
          startDate.format("YYYYMMDDHHmm"),
          endDate.format("YYYYMMDDHHmm"),
          answerStatusItems[1].value,
          orderType,
          orderBy,
        );
      } else {
        res = await inquiryApi.readRecommendInquiryList(
          offset,
          pageSize,
          searchOptions.startDate.format("YYYYMMDDHHmm"),
          searchOptions.endDate.format("YYYYMMDDHHmm"),
          searchOptions.answerStatus,
          orderType,
          orderBy,
        );
      }
      if (res.code === 200) {
        console.log("readInquiryList result", res.result);
        setInquiryList(res.result.inquiryList);
        setTotalSize(res.result.totalCnt);
        if (searchText && typeof searchText === "number") {
          setIsOpen(true);
          getInquiryOne(searchText);
        }
      } else {
        throw "해당 상담 리스트 정보를 가져오는데 실패했습니다.\n다시 시도하시거나 관리자에게 문의하시길 바랍니다.";
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getInquiryList read error", error);
      alert(error);
    }
  };

  const getInquiryOne = async (inquiry_id) => {
    setIsLoading(false);
    try {
      const res = await inquiryApi.getRecommendInquiryOne(inquiry_id);
      if (res.code === 200) {
        console.log("getInquiryOne result", res.result);
        setSelectInquiry({
          inquiry: res.result.inquiryDTO,
          answerList: res.result.inquiryAnswerListWithProduct,
        });
      } else {
        throw "해당 상담 정보를 가져오는데 실패했습니다.\n다시 시도하시거나 관리자에게 문의하시길 바랍니다.";
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getInquiryOne read error", error);
      alert(error);
    }
  };

  /**
   * handleSearch - 추천이유 검색
   */
  const handleSearchRecommendReason = async (searchWord) => {
    setIsLoading(true);
    try {
      let param = {
        searchKeywords: searchWord,
      };
      const res = await inquiryApi.searchRecommendReason(param);
      if (res.code === 200) {
        if (res.result?.length > 0) {
          let rowKeyList = [];
          let rowList = [];
          for (const reason of selectedReasonList) {
            if (res.result.some((result) => result.id === reason.id)) {
              rowKeyList.push(reason.id);
              rowList.push(reason);
            }
          }
          setSelectedReasonRowKey(rowKeyList);
          setSelectedReasonRow(rowList);
        } else {
          setSelectedReasonRowKey([]);
          setSelectedReasonRow([]);
        }
        setRecommendReasonList(res.result);
        setIsLoading(false);
      } else {
        throw "추천 이유를 찾아오지 못했습니다. 다시 시도해주세요.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  /**
   * handleSearch - 상품 검색
   */
  const handleSearchProduct = async (searchWord) => {
    setIsLoading(true);
    try {
      const res = await productApi.readProductListAll(
        0,
        "",
        searchWord,
        "",
        "product_id",
        "desc",
        user.id === 724 ? 1 : user.id,
      );
      if (res.code === 200) {
        if (res.result?.length > 0) {
          let rowKeyList = [];
          let rowList = [];
          for (const product of selectedProductList) {
            if (
              res.result.some(
                (result) => result.product_id === product.product_id,
              )
            ) {
              rowKeyList.push(product.product_id);
              rowList.push(product);
            }
          }
          setSelectedRowKey(rowKeyList);
          setSelectedRow(rowList);
        } else {
          setSelectedRowKey([]);
          setSelectedRow([]);
        }
        setProductItemList(res.result);
        setIsLoading(false);
      } else {
        throw "상품 정보를 찾아오지 못했습니다. 다시 시도해주세요.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      alert(error);
    }
  };

  /**
   * 상담 답변 등록하기
   */
  const recommendInquiryAnswerCreate = async () => {
    if (
      window.confirm(
        `${selectInquiry.inquiry.created_by_name}님의 질문에 아래에 작성하신 내용으로 답변하시겠습니까?`,
      )
    ) {
      setIsLoading(true);
      try {
        let inquiryAnswerList = [];
        let productRecommendStr = "";
        if (recommendInquiryAnswer.greetings?.length !== 0) {
          const startAnswer = {
            inquiry_id: selectInquiry.inquiry.id,
            content: recommendInquiryAnswer.greetings,
            created_by: user.id,
          };
          inquiryAnswerList.push(startAnswer);
        }
        for (const row of selectedProductList) {
          const recommendProduct = {
            inquiry_id: selectInquiry.inquiry.id,
            content: row.hasOwnProperty("content") ? row.content : null,
            recommend_id: row.product_id,
            recommend_target_id: row.target_id,
            recommend_tag: row.hasOwnProperty("recommend_tag")
              ? row.recommend_tag
              : null,
            created_by: user.id,
          };
          if (
            row.hasOwnProperty("content") &&
            typeof row.content === "string" &&
            row.content.trim()?.length !== 0
          ) {
            productRecommendStr += row.content.trim();
            productRecommendStr += "\n\n";
          }
          inquiryAnswerList.push(recommendProduct);
        }
        if (recommendInquiryAnswer.additional?.length !== 0) {
          const additionalAnswer = {
            inquiry_id: selectInquiry.inquiry.id,
            content: recommendInquiryAnswer.additional,
            created_by: user.id,
          };
          inquiryAnswerList.push(additionalAnswer);
        }
        const answerParam = {
          inquiryAnswerList: inquiryAnswerList,
        };
        console.log("inquiryAnswerList register", inquiryAnswerList);
        const res = await inquiryApi.createRecommendInquiryAnswer(answerParam);
        if (res.code === 200) {
          alert(
            `${selectInquiry.inquiry.created_by_name}님의 질문에 대한 답변을 정상적으로 등록했습니다.`,
          );
          let memberContent =
            recommendInquiryAnswer.greetings +
            "\n\n" +
            (productRecommendStr?.length !== 0
              ? productRecommendStr + "\n"
              : "") +
            recommendInquiryAnswer.additional;
          // kakao 알림 보내기
          const kakaoAlertParam = {
            inquiryInfo: {
              id: selectInquiry.inquiry.id,
              checking_status: "board",
              created_by_name: selectInquiry.inquiry.created_by_name,
              question_date_str: moment(
                selectInquiry.inquiry.created_at,
              ).format("YYYY년 MM월 DD일 HH시 mm분"),
              content:
                memberContent?.length > 500
                  ? memberContent.substr(0, 500) + "..."
                  : memberContent,
              created_by: selectInquiry.inquiry.created_by,
            },
          };
          sendKakaoAlert(kakaoAlertParam);
          handleCancel();
          if (searchText && searchText === "unanswer") {
            getInquiryList(
              "custom",
              recordDates.startDate,
              recordDates.endDate,
            );
          }
          setIsLoading(false);
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        alert(error);
      }
    }
  };

  /**
   * 답변 등록 시, 카톡 알림보내기
   */
  const sendKakaoAlert = async (param) => {
    setIsLoading(true);
    setError("");
    try {
      const userRes = await userApi.getUserInfo(param.inquiryInfo.created_by);
      if (userRes.code === 200) {
        param["user"] = userRes.result;
        await pushApi.kakaoForInquiryMember(param);
      } else {
        alert("해당 문의에 대한 알림을 보내는데 실패하였습니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
      case "1year":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "years").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "years")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getInquiryList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      answerStatus: answerStatusItems[1].value,
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    getInquiryList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("updated_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
    setPageSize(pageSize);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 기존 답변 표출
   */
  const settingAnswer = () => {
    setIsLoading(true);
    let editRecommendInquiryAnswer = {};
    for (let i = 0; i < selectInquiry.answerList?.length; i++) {
      const answer = selectInquiry.answerList[i];
      if (i === 0 && answer.recommend_target_id === null) {
        // 인삿말 setting
        editRecommendInquiryAnswer["greetings"] = answer.content;
      } else if (answer.recommend_target_id === null) {
        // 추가 코멘트 setting
        editRecommendInquiryAnswer["additional"] = answer.content;
      }
    }
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings: editRecommendInquiryAnswer.hasOwnProperty("greetings")
        ? editRecommendInquiryAnswer.greetings
        : "",
      additional: editRecommendInquiryAnswer.hasOwnProperty("additional")
        ? editRecommendInquiryAnswer.additional
        : "",
    });
    setIsLoading(false);
  };

  /**
   * 상담 상세보기 Modal cancel handler
   */
  const handleCancel = () => {
    setSelectInquiry({});
    setSelectedReasonRowKey([]);
    setSelectedReasonRow([]);
    setSelectedReasonList([]);
    setSelectedNutrientsList([]);
    setSelectedRowKey([]);
    setSelectedRow([]);
    setSelectedProductList([]);
    // searchReasonInput.current.state.value = null
    searchInput.current.state.value = null;
    if (searchText && typeof searchText === "number") {
      setIsSearchText("");
    }
    setIsOpen(false);
  };

  /**
   * handleRowEvent - 추천 이유 선택
   */
  const handleReasonRowEvent = (record) => {
    return {
      onClick: (_) => {
        let editTotalRow = [];
        let editRow = [];
        let editRowKey = [];
        const greetingsList = recommendInquiryAnswer.greetings.split(":)");
        const splitted = greetingsList[1].split("\n");
        const findReasonStrIdx = splitted.findIndex((str) =>
          str.includes("위와 같은 이유로"),
        );
        const greetingsStart = greetingsList[0] + ":)";
        const greetingsEnd = splitted.slice(findReasonStrIdx).join("\n");
        const copyReasonList = splitted.slice(0, findReasonStrIdx);
        if (copyReasonList?.length > 2 && copyReasonList[0] === "") {
          copyReasonList.shift();
        }
        let reasonStr = copyReasonList.join("\n");
        const reasonList = reasonStr.split("\n").filter((str) => str !== "");
        const selectReasonList = selectedReasonList.map(
          (reason) => reason.reason,
        );
        if (selectReasonList.includes(record.reason)) {
          editTotalRow = selectedReasonList.filter(
            (row) => row.reason !== record.reason,
          );
          editRow = selectedReasonRow.filter(
            (row) => row.reason !== record.reason,
          );
          editRowKey = selectedReasonRowKey.filter((key) => key !== record.id);
        } else {
          editTotalRow = [...selectedReasonList, record];
          editRow = [...selectedReasonRow, record];
          editRowKey = [...selectedReasonRowKey, record.id];
        }
        for (const row of editTotalRow) {
          if (!reasonList.includes(row.reason)) {
            reasonStr += `${
              row.reason.includes("XX")
                ? row.reason.replaceAll(
                    "XX",
                    selectInquiry.inquiry.created_by_name,
                  )
                : row.reason
            }\n`;
          } else {
            const findIdx = reasonList.findIndex(
              (reason) => reason === row.reason,
            );
            if (findIdx !== -1) {
              reasonList.splice(findIdx, 1);
            }
          }
        }
        if (reasonList?.length > 0) {
          for (const reason of reasonList) {
            reasonStr = reasonStr.replace(`${reason}\n`, "");
          }
        }
        if (reasonStr === "\n") {
          reasonStr = "";
        }
        setSelectedReasonRowKey(editRowKey);
        setSelectedReasonRow(editRow);
        setSelectedReasonList(editTotalRow);
        setRecommendInquiryAnswer({
          ...recommendInquiryAnswer,
          greetings:
            greetingsStart +
            "\n" +
            reasonStr +
            "\n" +
            (greetingsEnd.includes(":)")
              ? greetingsEnd
              : greetingsEnd + ":) )"),
        });
      },
    };
  };

  /**
   * 영양소 선택하기
   */
  const handleNutrientsSelect = (e) => {
    const { value, checked } = e.target;
    let editSelected = [];
    const greetingsList = recommendInquiryAnswer.greetings.split("님께는 ");
    const splittedGreetingList = greetingsList[1].split("필요한 것으로");
    const greetingsStart = greetingsList[0] + "님께는 ";
    const greetingsEnd = splittedGreetingList[1];
    if (checked) {
      const addNutrients = {
        id: value.nutrient_id,
        name: value.nutrient_name,
      };
      editSelected = [...selectedNutrientsList, addNutrients];
    } else {
      let currProductList = [...selectedProductList];
      for (const product of currProductList) {
        if (
          product.hasOwnProperty("recommend_tag") &&
          product.recommend_tag.includes(value.nutrient_id)
        ) {
          const tagList = product.recommend_tag.split(",");
          const findIdx = tagList.findIndex((tag) => tag === value.nutrient_id);
          if (findIdx !== -1) {
            tagList.splice(findIdx, 1);
          }
          product.recommend_tag = tagList.join(",");
        }
      }
      setSelectedProductList(currProductList);
      editSelected = selectedNutrientsList.filter(
        (nutrients) => nutrients.id !== value.nutrient_id,
      );
    }
    const nutrientsNameList = editSelected.map((select) => select.name);
    setSelectedNutrientsList(editSelected);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsStart +
        nutrientsNameList.join(", ") +
        (editSelected?.length === 0 ? "필요한 것으로" : " 필요한 것으로") +
        greetingsEnd,
    });
  };

  /**
   * 선택상품별 영양소 선택하기
   */
  const handleNutrientsSelectForProduct = (e, currIdx) => {
    const { value, checked } = e.target;
    const currSelectedProductList = [...selectedProductList];
    if (checked) {
      if (
        !currSelectedProductList[currIdx].hasOwnProperty("recommend_tag") ||
        currSelectedProductList[currIdx]["recommend_tag"] === ""
      ) {
        currSelectedProductList[currIdx]["recommend_tag"] = value;
      } else {
        currSelectedProductList[currIdx]["recommend_tag"] =
          currSelectedProductList[currIdx]["recommend_tag"] + "," + value;
      }
    } else {
      const tagList =
        currSelectedProductList[currIdx]["recommend_tag"].split(",");
      const findIdx = tagList.findIndex((tag) => tag === value);
      if (findIdx !== -1) {
        tagList.splice(findIdx, 1);
      }
      currSelectedProductList[currIdx]["recommend_tag"] = tagList.join(",");
    }
    setSelectedProductList(currSelectedProductList);
  };

  /**
   * 영양소 태그 삭제하기
   */
  const handleDeleteNutrients = (id, e) => {
    e.preventDefault();
    let currProductList = [...selectedProductList];
    const greetingsList = recommendInquiryAnswer.greetings.split("님께는 ");
    const splittedGreetingList = greetingsList[1].split("필요한 것으로");
    const greetingsStart = greetingsList[0] + "님께는 ";
    const greetingsEnd = splittedGreetingList[1];
    const deleteNutrients = selectedNutrientsList.filter(
      (nutrients) => nutrients.id !== id,
    );
    const nutrientsNameList = deleteNutrients.map((select) => select.name);
    for (const product of currProductList) {
      if (
        product.hasOwnProperty("recommend_tag") &&
        product.recommend_tag.includes(id)
      ) {
        const tagList = product.recommend_tag.split(",");
        const findIdx = tagList.findIndex((tag) => tag === id);
        if (findIdx !== -1) {
          tagList.splice(findIdx, 1);
        }
        product.recommend_tag = tagList.join(",");
      }
    }
    setSelectedNutrientsList(deleteNutrients);
    setSelectedProductList(currProductList);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsStart +
        nutrientsNameList.join(", ") +
        (deleteNutrients?.length === 0 ? "필요한 것으로" : " 필요한 것으로") +
        greetingsEnd,
    });
  };

  /**
   * handleRowEvent - 상품 선택
   */
  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        let editTotalRow = [];
        let editRow = [];
        let editRowKey = [];
        const greetingsList =
          recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
        let productNameStr = greetingsList[1].split("추천드립니다.")[0];
        const productNameList = productNameStr.split("\n");
        if (productNameList?.length === 1 && productNameList[0] === "") {
          productNameList.pop();
        }
        const productIdList = selectedProductList.map(
          (product) => product.product_id,
        );
        if (productIdList.includes(record.product_id)) {
          editTotalRow = selectedProductList.filter(
            (row) => row.product_id !== record.product_id,
          );
          editRow = selectedRow.filter(
            (row) => row.product_id !== record.product_id,
          );
          editRowKey = selectedRowKey.filter(
            (key) => key !== record.product_id,
          );
        } else {
          editTotalRow = [...selectedProductList, record];
          editRow = [...selectedRow, record];
          editRowKey = [...selectedRowKey, record.product_id];
        }
        for (const row of editTotalRow) {
          if (!productNameStr.includes(row.product_name)) {
            productNameStr += `"[${row.product_brand_name}] ${row.product_name}"\n`;
          } else {
            const findIdx = productNameList.findIndex((productName) =>
              productName.includes(row.product_name),
            );
            if (findIdx !== -1) {
              productNameList.splice(findIdx, 1);
            }
          }
          if (!row.hasOwnProperty("content")) {
            if (row.information_3 !== null) {
              row["content"] =
                row.information_1 +
                "\n\n" +
                row.information_2 +
                "\n\n" +
                row.information_3;
            } else if (row.information_2 !== null) {
              row["content"] = row.information_1 + "\n\n" + row.information_2;
            } else if (row.information_1 !== null) {
              row["content"] = row.information_1;
            } else {
              row["content"] = null;
            }
          }
          if (!row.hasOwnProperty("recommend_tag")) {
            row["recommend_tag"] = "";
          }
        }
        productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
        if (productNameList?.length > 0) {
          for (const productName of productNameList) {
            const deleteName = productName.replace(/(["'])\s/gim, `"`);
            productNameStr = productNameStr.replace(`${deleteName}\n`, "");
          }
        }
        productNameStr = productNameStr + "추천드립니다.";
        const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
        if (lastIdx !== -1) {
          productNameStr =
            productNameStr.substring(0, lastIdx) +
            " " +
            productNameStr.substring(lastIdx + 1);
        }
        setSelectedRowKey(editRowKey);
        setSelectedRow(editRow);
        setSelectedProductList(editTotalRow);
        setRecommendInquiryAnswer({
          ...recommendInquiryAnswer,
          greetings:
            greetingsList[0] +
            "이에 관련한 영양제로는\n" +
            productNameStr +
            (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
            greetingsList[1].split("추천드립니다.")[1],
        });
      },
    };
  };

  /**
   * 추천 상품 리스트 해제
   */
  const deleteRecommendProduct = (productId) => {
    const greetingsList =
      recommendInquiryAnswer.greetings.split("이에 관련한 영양제로는\n");
    let productNameStr = greetingsList[1].split("추천드립니다.")[0];
    const productNameList = productNameStr.split("\n");
    if (productNameList?.length === 1 && productNameList[0] === "") {
      productNameList.pop();
    }

    const deletedProductList = selectedProductList.filter(
      (row) => row.product_id !== productId,
    );
    if (selectedRowKey.includes(productId)) {
      const deletedRowKeys = selectedRowKey.filter((key) => key !== productId);
      const deletedRows = selectedRow.filter(
        (row) => row.product_id !== productId,
      );
      setSelectedRowKey(deletedRowKeys);
      setSelectedRow(deletedRows);
    }
    for (const row of deletedProductList) {
      if (!productNameStr.includes(row.product_name)) {
        productNameStr += `"${row.product_name}"\n`;
      } else {
        const findIdx = productNameList.findIndex((productName) =>
          productName.includes(row.product_name),
        );
        if (findIdx !== -1) {
          productNameList.splice(findIdx, 1);
        }
      }
    }
    productNameStr = productNameStr.replace(/(["'])\s/gim, `"\n`);
    if (productNameList?.length > 0) {
      for (const productName of productNameList) {
        const deleteName = productName.replace(/(["'])\s/gim, `"`);
        productNameStr = productNameStr.replace(`${deleteName}\n`, "");
      }
    }
    productNameStr = productNameStr + "추천드립니다.";
    const lastIdx = productNameStr.lastIndexOf(`\n추천드립니다.`);
    if (lastIdx !== -1) {
      productNameStr =
        productNameStr.substring(0, lastIdx) +
        " " +
        productNameStr.substring(lastIdx + 1);
    }
    setSelectedProductList(deletedProductList);
    setRecommendInquiryAnswer({
      ...recommendInquiryAnswer,
      greetings:
        greetingsList[0] +
        "이에 관련한 영양제로는\n" +
        productNameStr +
        (productNameStr.includes("추천드립니다.") ? "" : "추천드립니다.") +
        greetingsList[1].split("추천드립니다.")[1],
    });
  };

  /**
   * 추천 상품 선택 이유 작성
   */
  const recommendProductReason = (idx, value) => {
    let currRow = [...selectedProductList];
    currRow[idx]["content"] = value;
    setSelectedProductList(currRow);
  };

  return (
    <>
      <ContentHeaderComponent title="상담 게시판" />
      <div className="product-register-wrap">
        {/*상담 게시판 검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            className="center-label"
            label="답변상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={answerStatusItems}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  answerStatus: e.target.value,
                })
              }
              value={searchOptions.answerStatus}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={"middle"} style={{ gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                allowClear={false}
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                allowClear={false}
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*상담 게시판 목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div>
            <span className="product-register-box-title">
              상담 목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">등록일순</span>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            className="recommend-inquiry-table-wrap"
            columns={columns}
            dataSource={inquiryList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="id"
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              total={totalSize}
              onChange={handleChangePagination}
              // onShowSizeChange={pageSizeChange}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>

      {/*상담 질의 Modal*/}
      <Modal
        title="문의 상세보기"
        visible={isOpen}
        centered={true}
        onCancel={handleCancel}
        width={"80%"}
        wrapClassName="recommend-inquiry-modal-wrap"
        footer={[
          <Button
            key="submit"
            className="recommend-inquiry-modal-button register"
            onClick={recommendInquiryAnswerCreate}
            disabled={
              selectInquiry.hasOwnProperty("answerList") &&
              selectInquiry.answerList?.length > 0
            }
          >
            {selectInquiry.hasOwnProperty("answerList") &&
            selectInquiry.answerList?.length > 0
              ? "수정"
              : "등록"}
          </Button>,
          <Button
            key="back"
            className="recommend-inquiry-modal-button cancel"
            onClick={handleCancel}
          >
            취소
          </Button>,
        ]}
      >
        <div className="product-register-wrap" style={{ margin: 0 }}>
          {/*문의글*/}
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span
              className="product-register-box-title"
              style={{ fontSize: 20 }}
            >
              문의글
            </span>
          </Row>
          {Object.keys(selectInquiry)?.length > 0 ? (
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "20px 25px 35px",
                height: "fit-content",
              }}
            >
              <div
                className="product-register-box-title"
                style={{ fontSize: 20, fontWeight: "bold" }}
              >
                {selectInquiry.inquiry.title}
              </div>
              <div
                className="recommend-inquiry-question-text"
                style={{ fontSize: 18, marginTop: 6, marginBottom: 22 }}
              >
                {selectInquiry.inquiry.created_by_name}{" "}
                <span className="inquiry-date-text">
                  |{" "}
                  {moment(selectInquiry.inquiry.updated_at).format(
                    "YYYY.MM.DD HH:mm",
                  )}
                </span>
              </div>
              <div className="recommend-inquiry-question-text">
                {selectInquiry.inquiry.content}
              </div>
              {selectInquiry.inquiry.img_quantity !== 0 ? (
                <Row
                  justify="space-around"
                  align="middle"
                  className="recommend-inquiry-img-wrap"
                >
                  {selectInquiry.inquiry.img_type
                    .split("-")
                    .map((imgType, idx) => (
                      <img
                        key={`recommend_inquiry_${idx}`}
                        className="recommend-inquiry-img"
                        src={`${process.env.REACT_APP_S3_HOST}/image/inquiry/notice/${selectInquiry.inquiry.created_by}/${selectInquiry.inquiry.id}_${idx}.${imgType}`}
                      />
                    ))}
                </Row>
              ) : null}
            </div>
          ) : null}

          {/*답변 - 인삿말*/}
          <Row
            className="product-register-border-box add-background-color"
            wrap={false}
            style={{ marginTop: 30 }}
          >
            {/*<span className="product-register-box-title" style={{ fontSize: 20 }}>인삿말</span>*/}
            <span
              className="product-register-box-title"
              style={{ fontSize: 20 }}
            >
              추천 영양제
            </span>
          </Row>
          <div
            className="product-register-border-box add-background-color"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "24px 27px 25px 25px",
              height: "fit-content",
            }}
          >
            <Search
              className="search-input-wrap"
              ref={searchInput}
              placeholder="상품명, 브랜드명을 검색해주세요."
              onSearch={handleSearchProduct}
            />
            <Table
              className="inquiry-recommend-product-search-table"
              rowSelection={productRowSelection}
              columns={productColumns}
              dataSource={productItemList}
              loading={isLoading}
              onRow={handleRowEvent}
              bordered
              size="small"
              rowKey="product_id"
              rowClassName="coupon-table-row"
              scroll={{ x: "max-content", y: "calc(190px - 48px)" }}
              tableLayout="auto"
              pagination={false}
              style={{ margin: 0 }}
            />
          </div>

          {/*답변 - 추천이유*/}
          {/*<div className="product-register-border-box add-background-color" wrap={false} style={{ borderTop: 0, padding: "22px 27px 39px 25px", height: "fit-content" }}>*/}
          {/*    <div className="product-register-box-title" style={{ fontSize: 20 }}>추천이유</div>*/}
          {/*    <Search*/}
          {/*        className="search-input-wrap"*/}
          {/*        ref={searchReasonInput}*/}
          {/*        placeholder="(,)로 구분하여 검색해주세요."*/}
          {/*        onSearch={handleSearchRecommendReason}*/}
          {/*    />*/}
          {/*    <Table*/}
          {/*        className="inquiry-recommend-product-search-table"*/}
          {/*        rowSelection={reasonRowSelection}*/}
          {/*        columns={reasonColumns}*/}
          {/*        dataSource={recommendReasonList}*/}
          {/*        loading={isLoading}*/}
          {/*        onRow={handleReasonRowEvent}*/}
          {/*        bordered*/}
          {/*        size="small"*/}
          {/*        rowKey="id"*/}
          {/*        rowClassName="coupon-table-row"*/}
          {/*        scroll={{x: 'max-content', y: 'calc(190px - 48px)'}}*/}
          {/*        tableLayout="auto"*/}
          {/*        pagination={false}*/}
          {/*        style={{ margin: 0 }}*/}
          {/*    />*/}
          {/*</div>*/}

          {/*답변 - 영양소*/}
          {/*<div className="product-register-border-box" wrap={false} style={{ marginTop: 32, padding: "26px 27px 23px 25px", height: "fit-content" }}>*/}
          {/*    <Row wrap={false} className="inquiry-select-nutrients-header-wrap">*/}
          {/*        <Col flex="none"><div className="inquiry-sub-recommend-header">영양소</div></Col>*/}
          {/*        <Col flex="auto"><Row gutter={[0, 8]}>*/}
          {/*            {selectedNutrientsList?.length > 0 && (<>{selectedNutrientsList.map((nutrients, idx) =>*/}
          {/*                <Tag key={`select_nutrients_${idx}`} className="select-nutrients-tag" closable onClose={(e) => handleDeleteNutrients(nutrients.id, e)}>{nutrients.name}</Tag>*/}
          {/*            )}</>)}*/}
          {/*        </Row></Col>*/}
          {/*    </Row>*/}
          {/*    <Collapse*/}
          {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
          {/*        defaultActiveKey={['vitamin']}*/}
          {/*        expandIconPosition={"right"}*/}
          {/*    >*/}
          {/*        <Panel header="비타민" key="vitamin">*/}
          {/*            <Row style={{rowGap: 8}}>*/}
          {/*                {nutrientsList.vitamin.map((vitamin, idx) =>*/}
          {/*                    <Col span={6}>*/}
          {/*                        <Checkbox*/}
          {/*                            key={`vitamin_${idx}`}*/}
          {/*                            id={vitamin.id}*/}
          {/*                            name="nutrient_vitamin"*/}
          {/*                            value={vitamin}*/}
          {/*                            onChange={handleNutrientsSelect}*/}
          {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === vitamin.nutrient_id)}*/}
          {/*                        >{vitamin.nutrient_name}</Checkbox>*/}
          {/*                    </Col>)}*/}
          {/*            </Row>*/}
          {/*        </Panel>*/}
          {/*    </Collapse>*/}
          {/*    <Collapse*/}
          {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
          {/*        expandIconPosition={"right"}*/}
          {/*    >*/}
          {/*        <Panel header="미네랄" key="mineral">*/}
          {/*            <Row style={{rowGap: 8}}>*/}
          {/*                {nutrientsList.mineral.map((mineral, idx) =>*/}
          {/*                    <Col span={6}>*/}
          {/*                        <Checkbox*/}
          {/*                            key={`mineral_${idx}`}*/}
          {/*                            id={mineral.id}*/}
          {/*                            name="nutrient_mineral"*/}
          {/*                            value={mineral}*/}
          {/*                            onChange={handleNutrientsSelect}*/}
          {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === mineral.nutrient_id)}*/}
          {/*                        >{mineral.nutrient_name}</Checkbox>*/}
          {/*                    </Col>)}*/}
          {/*            </Row>*/}
          {/*        </Panel>*/}
          {/*    </Collapse>*/}
          {/*    <Collapse*/}
          {/*        className="inquiry-sub-recommend-nutrients-wrap"*/}
          {/*        expandIconPosition={"right"}*/}
          {/*    >*/}
          {/*        <Panel header="뉴트리션" key="nutrition">*/}
          {/*            <Row style={{rowGap: 8}}>*/}
          {/*                {nutrientsList.nutrition.map((nutrition, idx) =>*/}
          {/*                    <Col span={6}>*/}
          {/*                        <Checkbox*/}
          {/*                            key={`nutrition_${idx}`}*/}
          {/*                            id={nutrition.id}*/}
          {/*                            name="nutrient_nutrition"*/}
          {/*                            value={nutrition}*/}
          {/*                            onChange={handleNutrientsSelect}*/}
          {/*                            checked={selectedNutrientsList.some((nutrients) => nutrients.id === nutrition.nutrient_id)}*/}
          {/*                        >{nutrition.nutrient_name}</Checkbox>*/}
          {/*                    </Col>)}*/}
          {/*            </Row>*/}
          {/*        </Panel>*/}
          {/*    </Collapse>*/}
          {/*</div>*/}

          {/*답변 - 추천 영양제*/}
          <div
            className="product-register-border-box add-background-color"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "22px 27px 11px 25px",
              height: "fit-content",
            }}
          >
            {/*<div className="product-register-box-title" style={{ fontSize: 20 }}>추천 영양제</div>*/}
            <div
              className="product-register-box-title"
              style={{ fontSize: 20, marginBottom: 20 }}
            >
              인삿말
            </div>
            <TextArea
              allowClear
              name="greetings"
              value={recommendInquiryAnswer.greetings}
              onChange={(e) =>
                setRecommendInquiryAnswer({
                  ...recommendInquiryAnswer,
                  [e.target.name]: e.target.value,
                })
              }
            />
            {selectedProductList.map((row, idx) => {
              if (idx === 0) {
                return (
                  <>
                    <div
                      className="product-register-box-title"
                      style={{ fontSize: 20, marginBottom: 10, marginTop: 10 }}
                    >
                      상품 추천 이유
                    </div>
                    <RecommendProductComponent
                      productInfo={row}
                      currIdx={idx}
                      deleteRecommendProduct={deleteRecommendProduct}
                      recommendProductReason={recommendProductReason}
                      selectedRow={selectedProductList}
                      selectedNutrients={selectedNutrientsList}
                      handleNutrientsSelect={handleNutrientsSelectForProduct}
                      colSpan={6}
                    />
                  </>
                );
              } else {
                return (
                  <RecommendProductComponent
                    productInfo={row}
                    currIdx={idx}
                    deleteRecommendProduct={deleteRecommendProduct}
                    recommendProductReason={recommendProductReason}
                    selectedRow={selectedProductList}
                    selectedNutrients={selectedNutrientsList}
                    handleNutrientsSelect={handleNutrientsSelectForProduct}
                    colSpan={6}
                  />
                );
              }
            })}
          </div>

          {/*답변 - 추가 코멘트*/}
          <Row
            className="product-register-border-box add-background-color"
            wrap={false}
            style={{ marginTop: 44 }}
          >
            <span
              className="product-register-box-title"
              style={{ fontSize: 20 }}
            >
              추가 코멘트
            </span>
          </Row>
          <div
            className="product-register-border-box add-background-color"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "24px 27px 25px 25px",
              height: "fit-content",
            }}
          >
            <TextArea
              allowClear
              name="additional"
              value={recommendInquiryAnswer.additional}
              onChange={(e) =>
                setRecommendInquiryAnswer({
                  ...recommendInquiryAnswer,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RecommendInquiryBoardComponent;
